import React from 'react';
import { MapPin, Phone, Mail, Clock, Instagram, Facebook, Heart } from 'lucide-react';
import { contactInfo, businessHours } from '../data/mock';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const handleWhatsAppClick = () => {
    window.open(
      `https://wa.me/${contactInfo.whatsapp}?text=Olá! Gostaria de mais informações.`,
      '_blank'
    );
  };

  return (
    <footer id="contato" className="bg-[var(--color-brown-dark)] text-white">
      {/* Main Footer */}
      <div className="container mx-auto px-6 py-16">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand */}
          <div className="lg:col-span-1">
            <img
              src="https://customer-assets.emergentagent.com/job_lashdesigner/artifacts/poqh7fvv_Design%20sem%20nome%20%282%29.png"
              alt="Jani Ribeiro Lash Designer"
              className="h-14 w-auto mb-6"
              style={{ filter: 'brightness(0) invert(1)', opacity: 0.9 }}
            />
            <p className="text-[var(--color-nude-dark)] text-sm leading-relaxed">
              A arte de realçar o seu olhar com técnicas exclusivas e produtos de alta qualidade.
            </p>
          </div>

          {/* Contact Info */}
          <div>
            <h4 
              className="text-lg mb-6 text-[var(--color-rose-gold-light)]"
              style={{ fontFamily: 'var(--font-display)' }}
            >
              Contato
            </h4>
            <ul className="space-y-4">
              <li>
                <button
                  onClick={handleWhatsAppClick}
                  className="flex items-center gap-3 text-[var(--color-nude-dark)] hover:text-white transition-colors"
                >
                  <Phone size={18} className="text-[var(--color-rose-gold)]" />
                  <span>(47) 99765-3276</span>
                </button>
              </li>
              <li>
                <a
                  href={`mailto:${contactInfo.email}`}
                  className="flex items-center gap-3 text-[var(--color-nude-dark)] hover:text-white transition-colors"
                >
                  <Mail size={18} className="text-[var(--color-rose-gold)]" />
                  <span className="text-sm">{contactInfo.email}</span>
                </a>
              </li>
              <li className="flex items-start gap-3 text-[var(--color-nude-dark)]">
                <Clock size={18} className="text-[var(--color-rose-gold)] mt-0.5" />
                <span>{businessHours.note}</span>
              </li>
            </ul>
          </div>

          {/* Location */}
          <div>
            <h4 
              className="text-lg mb-6 text-[var(--color-rose-gold-light)]"
              style={{ fontFamily: 'var(--font-display)' }}
            >
              Localização
            </h4>
            <div className="flex items-start gap-3 text-[var(--color-nude-dark)]">
              <MapPin size={18} className="text-[var(--color-rose-gold)] mt-0.5 flex-shrink-0" />
              <div className="text-sm leading-relaxed">
                <p>{contactInfo.address.street}</p>
                <p>{contactInfo.address.neighborhood}</p>
                <p>{contactInfo.address.city} - {contactInfo.address.state}</p>
                <p>CEP: {contactInfo.address.cep}</p>
                <p className="text-[var(--color-rose-gold-light)] mt-2 italic">
                  {contactInfo.address.reference}
                </p>
              </div>
            </div>
          </div>

          {/* Social & CTA */}
          <div>
            <h4 
              className="text-lg mb-6 text-[var(--color-rose-gold-light)]"
              style={{ fontFamily: 'var(--font-display)' }}
            >
              Redes Sociais
            </h4>
            <div className="flex gap-4 mb-8">
              <a
                href="#"
                className="w-10 h-10 rounded-full bg-[var(--color-brown)] flex items-center justify-center hover:bg-[var(--color-rose-gold)] transition-colors"
                aria-label="Instagram"
              >
                <Instagram size={20} />
              </a>
              <a
                href="#"
                className="w-10 h-10 rounded-full bg-[var(--color-brown)] flex items-center justify-center hover:bg-[var(--color-rose-gold)] transition-colors"
                aria-label="Facebook"
              >
                <Facebook size={20} />
              </a>
            </div>
            <button
              onClick={handleWhatsAppClick}
              className="w-full bg-green-500 hover:bg-green-600 text-white py-3 px-6 rounded-full font-medium transition-all flex items-center justify-center gap-2"
            >
              <Phone size={18} />
              Agendar Agora
            </button>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-[var(--color-brown)]">
        <div className="container mx-auto px-6 py-6">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-sm text-[var(--color-nude-dark)]">
              © {currentYear} Jani Ribeiro Lash Designer. Todos os direitos reservados.
            </p>
            <p className="text-sm text-[var(--color-nude-dark)] flex items-center gap-1">
              Feito com <Heart size={14} className="text-[var(--color-rose-gold)]" fill="currentColor" /> em São Bento do Sul
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
